import { forwardRef } from "react";
import { Icon, type Props } from "./DismissIcon.Parts";

export const DismissIcon = forwardRef<SVGSVGElement, Props>(
  ({ small, ...props }, ref) => (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      $small={small}
      ref={ref}
      {...props}
    >
      <path
        d="M13.0299 0.191685L15.808 2.96972C16.0645 3.22623 16.0635 3.64016 15.808 3.89574L11.7039 7.99983L15.808 12.1039C16.0645 12.3604 16.0635 12.7743 15.808 13.0299L13.0299 15.808C12.7743 16.0635 12.3604 16.0645 12.1039 15.808L7.99983 11.7039L3.89574 15.808C3.64016 16.0635 3.22623 16.0645 2.96972 15.808L0.191685 13.0299C-0.0638945 12.7743 -0.0638945 12.3595 0.191685 12.1039L4.29577 7.99983L0.191685 3.89574C-0.0638949 3.64016 -0.0638949 3.2253 0.191685 2.96972L2.96972 0.191685C3.2253 -0.0638949 3.64016 -0.0638949 3.89574 0.191685L7.99983 4.29577L12.1039 0.191685C12.3595 -0.0638945 12.7743 -0.0638945 13.0299 0.191685Z"
        fill="currentColor"
      />
    </Icon>
  ),
);
